import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 210  -  等待
 */

export default class EventWait extends EventBase {
  /**
   * 构造函数
   */
  constructor() {
    super()
    this.Parameter = ['10', '0']
  }

  // #region 事件内主要属性参数
  /**
   * 等待时间，固定存储为帧数。
   */
  get Time() {
    return Number(this.Parameter?.[0] ?? '0') || 0
  }
  set Time(value) {
    this.Parameter && (this.Parameter[0] = String(value ?? 0))
  }

  /**
   * 编辑器显示单位：0=帧，1=秒；运行时仍读取 Time 帧数。
   */
  get Type() {
    return parseInt(this.Parameter?.[1] ?? '0') || 0
  }

  set Type(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  // #endregion

  /**
   * 事件ID
   */
  Code = EventID.Wait

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
